import { take, call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { getAppCOnfigs } from '../utils/requests';
import { appConfigsSuccess, appConfigsFailed } from '../actions/appConfigs';

export function* appConfigWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.APP_CONFIGS_REQUEST, appConfigRequestWatcher);
}

function* appConfigRequestWatcher(action) {
    try {
      const response = yield call(getAppCOnfigs);

      yield put(appConfigsSuccess(response.data));

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(appConfigsFailed(errorPayload));
    }
}